const hasFilledEntries = value => !hasValue(value) || Object.values(value).every(entry => !!entry);

const hasLengthEqualTo = length => value => !hasValue(value) || value.toString().length === length;

const hasLengthUpTo = length => value => !hasValue(value) || value.toString().length >= length;

const hasLessThan = length => value => !hasValue(value) || value.toString().length <= length;

const hasLessValuesThan = length => value => !hasValues(value) || value.length <= length;

const hasMoreThan = length => value => !hasValue(value) || value.toString().length >= length;

const hasOnlyLetters = value => !hasValue(value) || /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]+$/.test(value);

const hasOnlyNumbers = value => !hasValue(value) || /^[0-9]*$/.test(value);

const hasValue = value => !!value;

const hasValues = value => !hasValue(value) || !!value.length;

const isValidMail = value => !hasValue(value) || /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);

export default {
    hasFilledEntries,
    hasLengthEqualTo,
    hasLengthUpTo,
    hasLessThan,
    hasLessValuesThan,
    hasMoreThan,
    hasOnlyLetters,
    hasOnlyNumbers,
    hasValue,
    hasValues,
    isValidMail
};
